
export enum DRAGGING_TYPES {
  RACK_ITEM = "rack_item",
  UNRACK_ITEM = "unrack_item",
  AVAILABLE_EQUIPMENT = "available_equipment",
  AVAILABLE_RACK = "available_rack",
  WORK_EQUIPMENT = "work_equipment",
  RACK_DRAG = "rack_drag",
}
export interface IBuildingName {
  readonly name: string;
  readonly id: string;
}

